module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-view",
    style: ({
      height: _vm.height + 'px'
    }),
    attrs: {
      "id": "allmap"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49420d54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/ztMap.vue
// module id = 1033
// module chunks = 0